import React, { useEffect, useMemo, useState } from "react";
import { InputField } from "../../../../Components/formElements/InputField";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";

//Redux
import { useSelector } from "react-redux"; //useDispatch
//Service
import ItemService from "../../../../services/customer_appCommonService";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import {
  getTodayDate,
  validateRegistration,
  validateRequired,
} from "../../../../common/Validations";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import Layout from "../../../../Layout/Layout";
import MaterialSelectionModal from "../Scheduling/MaterialSelectionModal";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE: "Enter a 6-character postal code.",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const CreatePurchase = () => {
  localStorage.setItem("menu", "Purchase");
  localStorage.setItem("submenu", "Purchase List");

  const [getCustomer, setCustomer] = useState([]);
  const navigate = useNavigate();

  // eslint-disable-next-line
  const purchaseCompany = [
    { id: 1, name: "Ramco", code: "RAM001" },
    { id: 2, name: "ACC", code: "KAR002" },
    { id: 3, name: "Maha", code: "MAH003" },
  ];
  let userData = useSelector((state) => state?.user?.data);

  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Material",
      selector: (row) => row.materialLongText,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.materialLongText}{" "}
          </p>
          <p className="m-0 p-0 ">{row.materialCode} </p>
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row) => row.uOM || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Qty",
      selector: (row) => row.poOrderQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="poOrderQuantity"
          placeholder=""
          value={row.poOrderQuantity || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Gross Value",
      selector: (row) => row.grossValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="grossValue"
          placeholder=""
          value={row.grossValue || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Dispatch Date",
      selector: (row) => row.dispatchDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="dispatchDate"
          type="date"
          placeholder=""
          value={row.dispatchDate || getTodayDate("")}
          disabled={false}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },

    {
      name: "Basic Amt",
      selector: (row) => row.poBasicAmount || "--",
      cell: (row) => <span>{row.poBasicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "IGST",
      selector: (row) => row.igstChecked || "--",
      cell: (row) => (
        <div>
          <input
            className="form-check-input"
            type="checkbox"
            checked={row.igstChecked || false}
            onChange={() => {
              setProductDetailsData((prev) =>
                prev.map((item) =>
                  item.local_id === row.local_id
                    ? {
                        ...item,
                        igstChecked: !item.igstChecked,
                        igstValue: !item.igstChecked
                          ? ""
                          : item.igstValue || "",
                        igstAmount: !item.igstChecked
                          ? 0
                          : item.igstAmount || 0,
                      }
                    : item
                )
              );
            }}
          />
          {row.igstChecked && (
            <InputField
              className="inputBox mt-1"
              name="igstValue"
              placeholder="IGST %"
              value={row.igstValue || ""}
              onChange={(event) =>
                handleInputChange(row.local_id, event, "Number")
              }
            />
          )}
        </div>
      ),
      width: "130px",
    },
    {
      name: "IGST Value",
      selector: (row) => row?.igstAmount || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "CGST%",
      selector: (row) => (row.igstChecked ? "0" : row?.cgst || "--"),
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => (row.igstChecked ? "0" : row?.sgst || "--"),
      sortable: true,
      width: "100px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button className="" onClick={() => removeProductDetails(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];

  const [modalShow, setModalShow] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  // const [godownData, setGodownData] = useState([]);

  const [purchaseData, setpurchaseData] = useState();
  const [getDropdownData, setDropdownData] = useState("");
  const [getProductDetailsData, setProductDetailsData] = useState([]); //productDetailsData
  const [getProductDetailsCol] = useState(productDetailsCol);
  const [disable, setDisabled] = useState(false);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // const [getParentCompanyCode, setParentCompanyCode] = useState([]);
  const [getCustomerDetails, setCustomerDetails] = useState(null);
  const [getCompanyDetails, setCompanyDetails] = useState(null);
  const [truckData, setTruckData] = useState([]);
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [formInputs, setFormInputs] = useState({
    generatedDate: "",
    invoiceNr: "",
    orderPlacedBy: "",
    customerDetails: "",
    emailAddress: "",
    deliveryAddress: "",
    customerDetailsIfOther: "",
    createdDate: new Date(),
    createdBy: userData?.userId,
    dispatchDate: getTodayDate(""),
    loadingTruckNo: "",
    loadingOtherTruckNo: "",
    godownAddress: "",
    debitAmount: 0,
    purchaseRemarks: "",
  });

  /* pop failure modal */
  const [validation, setValidation] = useState({});
  const [totals, setTotals] = useState({
    poTotalBags: 0,
    poTotalAmount: 0,
    poTotalCgst: 0,
    poTotalSgst: 0,
    poTotalIgst: 0,
    poTotalNetValue: 0,
  });

  const [cgstValue_14, setCgstValue_14] = useState(0);
  const [cgstValue_9, setCgstValue_9] = useState(0);
  const [sgstValue_14, setSgstValue_14] = useState(0);
  const [sgstValue_9, setSgstValue_9] = useState(0);

  useEffect(() => {
    let cgst14 = 0;
    let sgst14 = 0;
    let cgst9 = 0;
    let sgst9 = 0;

    getProductDetailsData.forEach((item) => {
      if (item.cgst === 14) {
        cgst14 += Number(item.cgstValue) || 0;
        sgst14 += Number(item.sgstValue) || 0;
      } else if (item.cgst === 9) {
        cgst9 += Number(item.cgstValue) || 0;
        sgst9 += Number(item.sgstValue) || 0;
      }
    });
    setCgstValue_14(cgst14);
    setSgstValue_14(sgst14);
    setCgstValue_9(cgst9);
    setSgstValue_9(sgst9);
  }, [getProductDetailsData]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  useEffect(() => {
    loadMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    if (getDropdownData?.textDesc === "customerNameDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      getCustomerDetail(getDropdownData?.id);
      setFormInputs((formInputs) => ({ ...formInputs, projectName: "" }));
    } else if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((prev) => ({
        ...prev,
        customerName: getDropdownData?.name, // Ramco
        customerCode: getDropdownData?.id, // ✅ FIXED → was `.code`
        customerDesc: getDropdownData?.desc || "",
      }));
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    } else if (getDropdownData?.textCode === "parentCompanyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    } else if (getDropdownData?.textDesc === "companyCodeDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      getCompanyMaster(getDropdownData?.id);
    } else if (getDropdownData?.textDesc === "godownAddressDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    } else if (getDropdownData?.textDesc === "loadingTruckNoDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const removeProductDetails = (local_id) => {
    setProductDetailsData((prevPrograms) => {
      const filteredData = prevPrograms.filter(
        (program) => program.local_id !== local_id
      );
      // Reset and update `local_id` sequentially
      const updatedData = filteredData.map((item, index) => ({
        ...item,
        local_id: index + 1, // Reset local_id after removal
        poOrderQuantity: "",
      }));
      return updatedData;
    });
  };

  // Igst calculation without sgst and cgst
  const handleInputChange = (local_id, event, type) => {
    const { name, value } = event.target;

    if (type === "Number" && isNaN(value)) {
      toast.error("Please enter a valid number");
      return;
    }
    setProductDetailsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id === local_id) {
          const updatedRow = { ...row, [name]: value };

          const poOrderQuantity = parseFloat(updatedRow?.poOrderQuantity) || 0;
          const reversePercentage =
            parseFloat(updatedRow.reversePercentage) || 0;

          // If igstChecked is true, ignore sgst and cgst
          const cgstPercent = row.igstChecked
            ? 0
            : parseFloat(updatedRow.cgst) || 0;
          const sgstPercent = row.igstChecked
            ? 0
            : parseFloat(updatedRow.sgst) || 0;
          const igstPercent = row.igstChecked
            ? parseFloat(updatedRow.igstValue) || 0
            : 0;

          const gst = cgstPercent + sgstPercent;
          updatedRow.gst = gst;

          if (name !== "grossValue" && name !== "igstValue") {
            return updatedRow;
          }

          if (name === "grossValue") {
            if (value === "") {
              updatedRow.grossValue = "";
              updatedRow.netValue = "";
              updatedRow.cgstValue = "";
              updatedRow.sgstValue = "";
              updatedRow.igstAmount = "";
              updatedRow.gstValue = "";
              updatedRow.poBasicAmount = "";
              updatedRow.basicPrice = "";
              updatedRow.unitPrice = "";
              updatedRow.rounded = "";
              updatedRow.difference = "";
            } else {
              const grossValue = parseFloat(value);
              const totalTaxPercent = cgstPercent + sgstPercent + igstPercent;

              if (!isNaN(grossValue) && totalTaxPercent !== 0) {
                const netValue = parseFloat(
                  (grossValue / (1 + totalTaxPercent / 100)).toFixed(2)
                );
                updatedRow.netValue = netValue;
                updatedRow.cgstValue = row.igstChecked
                  ? 0
                  : parseFloat(((cgstPercent * netValue) / 100).toFixed(2));
                updatedRow.sgstValue = row.igstChecked
                  ? 0
                  : parseFloat(((sgstPercent * netValue) / 100).toFixed(2));
                updatedRow.igstAmount = row.igstChecked
                  ? parseFloat(((igstPercent * netValue) / 100).toFixed(2))
                  : 0;
                updatedRow.gstValue =
                  updatedRow.cgstValue +
                  updatedRow.sgstValue +
                  updatedRow.igstAmount;

                updatedRow.poBasicAmount = netValue;
                updatedRow.grossValue = value;
                updatedRow.rounded = Math.round(grossValue);
                updatedRow.difference = (
                  updatedRow.rounded - grossValue
                ).toFixed(2);

                if (poOrderQuantity !== 0) {
                  updatedRow.basicPrice = parseFloat(
                    (netValue / poOrderQuantity).toFixed(2)
                  );
                }
                if (!isNaN(updatedRow.basicPrice) && reversePercentage !== 0) {
                  updatedRow.unitPrice = parseFloat(
                    (updatedRow.basicPrice * reversePercentage).toFixed(2)
                  );
                }
              }
            }
          }

          if (name === "igstValue" && row.igstChecked) {
            if (value === "") {
              updatedRow.igstValue = "";
              updatedRow.igstAmount = "";
              updatedRow.netValue = "";
              updatedRow.cgstValue = "";
              updatedRow.sgstValue = "";
              updatedRow.gstValue = "";
              updatedRow.poBasicAmount = "";
              updatedRow.basicPrice = "";
              updatedRow.unitPrice = "";
              updatedRow.rounded = "";
              updatedRow.difference = "";
            } else {
              const grossValue = parseFloat(updatedRow.grossValue) || 0;
              const igst = parseFloat(value) || 0;

              const totalTaxPercent = igst; // CGST and SGST are ignored

              if (grossValue > 0 && totalTaxPercent > 0) {
                const netValue = parseFloat(
                  (grossValue / (1 + totalTaxPercent / 100)).toFixed(2)
                );
                updatedRow.netValue = netValue;
                updatedRow.cgstValue = 0;
                updatedRow.sgstValue = 0;
                updatedRow.igstAmount = parseFloat(
                  ((igst * netValue) / 100).toFixed(2)
                );
                updatedRow.gstValue = parseFloat(
                  updatedRow.igstAmount.toFixed(2)
                );
                updatedRow.poBasicAmount = netValue;

                if (poOrderQuantity !== 0) {
                  updatedRow.basicPrice = parseFloat(
                    (netValue / poOrderQuantity).toFixed(2)
                  );
                }
                if (!isNaN(updatedRow.basicPrice) && reversePercentage !== 0) {
                  updatedRow.unitPrice = parseFloat(
                    (updatedRow.basicPrice * reversePercentage).toFixed(2)
                  );
                }

                updatedRow.rounded = Math.round(grossValue);
                updatedRow.difference = (
                  updatedRow.rounded - grossValue
                ).toFixed(2);
              }
            }
          }

          return updatedRow;
        }
        return row;
      })
    );
  };
  const customerDataDropdown = async () => {
    let obj = {
      queryName: "AllSupplier",
      page: 1,
      per_page: 10,
    };
    await ItemService.generateCustomerQuery(obj).then((item) => {
      if (item?.status === 200) {
        const transformed = item.data.map((cust) => ({
          id: cust.customerCode,
          name: cust.organisationName,
          desc: cust.organisationName,
          code: cust.customerCode,
          description: cust.organisationName,
        }));
        setCustomer(transformed);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };
  useEffect(() => {
    customerDataDropdown();
  }, []);

  const calculatedTotals = useMemo(() => {
    if (!getProductDetailsData || getProductDetailsData.length === 0) {
      return {
        poTotalBags: 0,
        poTotalAmount: "0.00",
        poTotalCgst: "0.00",
        poTotalSgst: "0.00",
        poTotalIgst: "0.00",
        poTotalNetValue: "0.00",
        poCgstValue_14: "0.00",
        poCgstValue_9: "0.00",
        poSgstValue_9: "0.00",
        poSgstValue_14: "0.00",
      };
    }
    const totals = getProductDetailsData.reduce(
      (acc, item) => {
        acc.poTotalBags += parseFloat(item.poOrderQuantity) || 0;
        acc.poTotalAmount += parseFloat(item.poBasicAmount) || 0;
        acc.poTotalCgst += parseFloat(item.cgstValue) || 0;
        acc.poTotalIgst += parseFloat(item.igstAmount) || 0;
        acc.poTotalSgst += parseFloat(item.sgstValue) || 0;
        acc.poTotalNetValue += parseFloat(item.grossValue) || 0;
        return acc;
      },
      {
        poTotalBags: 0,
        poTotalAmount: 0,
        poTotalCgst: 0,
        poTotalSgst: 0,
        poTotalIgst: 0,
        poTotalNetValue: 0,
      }
    );
    return {
      poTotalBags: parseFloat(totals.poTotalBags),
      poTotalAmount: parseFloat(totals.poTotalAmount.toFixed(2)),
      poTotalCgst: parseFloat(totals.poTotalCgst.toFixed(2)),
      poTotalIgst: parseFloat(totals.poTotalIgst.toFixed(2)),
      poTotalSgst: parseFloat(totals.poTotalSgst.toFixed(2)),
      poTotalNetValue: parseFloat(totals.poTotalNetValue.toFixed(2)),
      poCgstValue_14: parseFloat(cgstValue_14.toFixed(2)),
      poCgstValue_9: parseFloat(cgstValue_9.toFixed(2)),
      poSgstValue_9: parseFloat(sgstValue_9.toFixed(2)),
      poSgstValue_14: parseFloat(sgstValue_14.toFixed(2)),
    };
  }, [
    getProductDetailsData,
    cgstValue_14,
    cgstValue_9,
    sgstValue_14,
    sgstValue_9,
  ]);

  const rounded = Math.round(totals.poTotalNetValue); // Nearest whole number
  const difference = (rounded - totals.poTotalNetValue).toFixed(2);
  useEffect(() => {
    setTotals(calculatedTotals);
    setFormInputs((prev) => ({
      ...prev,
    }));
  }, [calculatedTotals]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const handleSave = async () => {
    const finalobj = getProductDetailsData.map((item) => ({
      ...item,
      ...formInputs,
      customerCode: formInputs.customerCode || getCustomerDetails?.customerCode,
      customerName: formInputs.customerName || getCustomerDetails?.customerName,
      loadingTruckNo: formInputs.loadingTruckNo,
      loadingTruckNoDescription: formInputs.loadingTruckNoDesc,
      loadingOtherTruckNo: formInputs.loadingOtherTruckNo,
      transporterDriverName: formInputs.transporterDriverName,
      godownAddress: formInputs.godownAddress,
      creditAmount: item.netValue,
      // purchaseRemarks:formInputs.purchaseRemarks,
    }));

    const filteredData = finalobj.map(
      ({ _id, purchaseRemarks, ...rest }) => rest
    );

    // ---------------- CREDIT PAYLOAD (Supplier/Customer gets credited) ----------------
    const obj = {
      data: {
        companyCode: filteredData[0].companyCode,
        companyCodeDesc: filteredData[0].companyCodeDesc,
        // customerCode: filteredData[0].customerCode || "",
        customerCode:
          filteredData[0].customerCode || getCustomerDetails?.customerCode,
        customerName:
          filteredData[0].customerName || getCustomerDetails?.customerName,
        deliveryName: filteredData[0].projectName,
        invoiceNr: formInputs?.invoiceNr,
        generatedDate: formInputs?.generatedDate,
        address: getCustomerDetails?.address,
        address2: getCustomerDetails?.address2,
        address3: getCustomerDetails?.address3,
        state: getCustomerDetails?.state,
        cityPostalCode: getCustomerDetails?.cityPostalCode,
        certifications: getCustomerDetails?.certifications,
        companyAddress: [
          getCompanyDetails?.address,
          getCompanyDetails?.address2,
          getCompanyDetails?.address3,
          getCompanyDetails?.city,
          getCompanyDetails?.state,
        ]
          .filter(Boolean)
          .join(" "),
        companyPostalCode: getCompanyDetails?.cityPostalCode,
        companyCertifications: getCompanyDetails?.certifications,
        companyContact: [
          { contant1: "9448380669" },
          { contant2: "7411677666" },
        ],
        companyMail: "svah2003@gmail.com",
        items: filteredData,
        poTotals: calculatedTotals,
        ewayBill: purchaseData.ewayBill,
        transaction: "Purchase",
        transactionType: "PO",
        poRoundOff: parseFloat(difference),
        purchaseRemarks: formInputs.purchaseRemarks,
      },
    };

    try {
      setDisabled(true);

      // 1. First call credit API
      const purchase = await ItemServiceV2.addInvoice(obj);

      if (purchase?.status === 200) {
        toast.success(purchase?.message || "Purchase Created successfully", {
          duration: 2000,
          position: "top-right",
        });
        // ✅ Navigate only after all success
        navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_LIST);
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      toast.error("Unexpected error! Please try again.", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });

    //truck number
    let obj2 = {
      codeType: "truckCode",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setTruckData(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // Onselect of Country state will load
  const getCustomerDetail = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemService.getCustomerDetail(obj1).then((item) => {
      if (item?.status === 200) {
        setCustomerDetails(item?.data[0] || null);
      } else {
        setCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  // Onselect of company, cuatomer will load
  const getCompanyMaster = async (code) => {
    let obj1 = {
      code: code,
    };
    await ItemServiceV2.getCompanyMaster(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyDetails(item?.data[0] || null);
      } else {
        setCompanyDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const handleGetSelectedMaterial = (selectedData) => {
    setProductDetailsData((prevData) => {
      const updatedData = [
        ...prevData,
        ...selectedData.map((item, index) => ({
          ...item,
          local_id: index + 1, // Continue local_id from previous data
          dispatchDate: getTodayDate(""),
          orderStatus: "Pending",
          poOrderQuantity: "",
          customerAddress: [
            getCustomerDetails?.address,
            getCustomerDetails?.address2,
            getCustomerDetails?.address3,
            getCustomerDetails?.state,
          ]
            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
            .join(" "),
          customerPostalCode: getCustomerDetails?.cityPostalCode,
          certifications: getCustomerDetails?.certifications,

          companyAddress: [
            getCompanyDetails?.address,
            getCompanyDetails?.address2,
            getCompanyDetails?.address3,
            getCompanyDetails?.city,
            getCompanyDetails?.state,
          ]
            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
            .join(" "),
          companyPostalCode: getCompanyDetails?.cityPostalCode,
          companyCertifications: getCompanyDetails?.certifications,
        })),
      ];

      // Remove duplicates based on _id
      const uniqueData = Array.from(
        new Map(updatedData.map((item) => [item._id, item])).values()
      );

      // Sort based on `local_id`
      const sortedData = uniqueData
        .map((item, index) => ({
          ...item,
          local_id: index + 1, // Reset local_id sequentially
        }))
        .sort((a, b) => a.local_id - b.local_id);

      return sortedData;
    });
  };
  /* Modal Function */
  const addProductDetails = () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.companyCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        companyCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    setModalShow(true);
  };

  useEffect(() => {
    if (formInputs.loadingTruckNo !== "000 - OTHERS") {
      setValidation((prev) => ({
        ...prev,
        loadingOtherTruckNo: "",
      }));
    }
  }, [formInputs.loadingTruckNo]);

  const hideModal = () => {
    setModalShow(false);
  };

  useEffect(() => {
    if (getCustomerDetails) {
      setFormInputs((prev) => ({
        ...prev,
        shippingAddress: [
          getCustomerDetails?.address,
          getCustomerDetails?.address2,
          getCustomerDetails?.address3,
          getCustomerDetails?.state,
        ]
          .filter(Boolean)
          .join("\n"),

        shippingPostalCode: getCustomerDetails?.cityPostalCode || "",
      }));
    }
  }, [getCustomerDetails]);

  const onInputChange = (e) => {
    const errors = {};
    const { name, value } = e.target;
    setFormInputs((prevInputs) => ({
      ...prevInputs,
      [name]: name === "loadingOtherTruckNo" ? value.toUpperCase() : value,
    }));
    validateRegistration(name === "loadingOtherTruckNo" ? value : "")
      ? (errors.loadingOtherTruckNo = "")
      : (errors.loadingOtherTruckNo = message.VALID_CONTACT_FIRST_NAME);
    setValidation((prev) => ({
      ...prev,
      [name]: value === "" ? "" : errors[name] || "",
    }));
  };

  useEffect(() => {
    setpurchaseData((purchaseData) => ({
      ...purchaseData,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Purchase</h2>
            <p className="subText">Create Purchase </p>
            <hr />
            {/* Purchase header */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Purchase Header</span>
                      <span className="subHeaderTitle">Purchase Header</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fs-5 mb-0">
                            {/* {purchaseData?.companyCodeDesc} */}
                          </p>
                          <p className="fs-5 mb-0">
                            {/* {purchaseData?.companyAddress} */}
                          </p>
                        </Col>
                        <Row>
                          {/* <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Company"
                              placeholder=""
                              data={getParentCompanyCode}
                              id="parentCompanyCode"
                              iconClassName="dropdownIcon"
                              name="parentCompanyCode"
                              code="parentCompanyCode"
                              description="parentCompanyCodeDesc"
                              setValue={formInputs.parentCompanyCode || ""}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.parentCompanyCode}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Company"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCode"
                              description="companyCodeDesc"
                              setValue={formInputs.companyCode || ""}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.companyCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Company Address"
                              name="companyAddress"
                              value={[
                                getCompanyDetails?.address,
                                getCompanyDetails?.address2,
                                getCompanyDetails?.address3,
                                getCompanyDetails?.city,
                                getCompanyDetails?.state,
                              ]
                                .filter(Boolean)
                                .join(" ")}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Invoice Nr"
                              name="invoiceNr"
                              value={formInputs?.invoiceNr || ""}
                              onChange={onInputChange}
                              error={validation.invoiceNr}
                              // disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Invoice Date"
                              name="generatedDate"
                              id="generatedDate"
                              value={formInputs?.generatedDate}
                              onChange={onInputChange}
                              // disabled={true}
                            />
                          </Col>
                        </Row>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Purchase:</p>

                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Supplier"
                                placeholder=""
                                data={getCustomer}
                                id="customerCode"
                                iconClassName="dropdownIcon"
                                name="customerCode"
                                code="customerCode"
                                description="customerName"
                                value={formInputs?.customerCode || ""}
                                getvalue={setDropdownData}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                id="purchaseRemarks"
                                className="inputBox"
                                label="Remark"
                                name="purchaseRemarks"
                                placeholder=""
                                value={formInputs.purchaseRemarks || ""}
                                onChange={onInputChange}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Godown:</p>
                          <Row>
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Godown"
                                placeholder=""
                                data={godownData}
                                id="godownAddress"
                                iconClassName="dropdownIcon"
                                name="godownAddress"
                                code="godownAddressCode"
                                description="godownAddressDesc"
                                setValue={formInputs?.godownAddress || ""}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation.godownAddress}
                              />
                            </Col> */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Truck Number"
                                placeholder=""
                                data={truckData}
                                id="loadingTruckNo"
                                iconClassName="dropdownIcon"
                                name="loadingTruckNo"
                                code="loadingTruckNoCode"
                                description="loadingTruckNoDesc"
                                setValue={formInputs?.loadingTruckNo || ""}
                                getvalue={setDropdownData}
                                required={false}
                                error={validation.loadingTruckNo}
                              />
                            </Col>
                            {formInputs?.loadingTruckNo === "000 - OTHERS" && (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Truck Nmber"
                                  name="loadingOtherTruckNo"
                                  value={formInputs?.loadingOtherTruckNo || ""}
                                  onChange={onInputChange}
                                  error={validation.loadingOtherTruckNo}

                                  // disabled={true}
                                />
                              </Col>
                            )}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Driver"
                                name="transporterDriverName"
                                value={formInputs?.transporterDriverName || ""}
                                onChange={onInputChange}
                                error={validation.transporterDriverName}
                                // disabled={true}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/* table */}
            <div
              className="accordion sri-venkateshwara mb-4"
              id="accordionExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Product Details</span>
                      <span className="subHeaderTitle">Product Details</span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <button className="btnTable" onClick={addProductDetails}>
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getProductDetailsCol}
                          data={getProductDetailsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*03 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle"> Purchase Details</span>
                      <span className="subHeaderTitle">Purchase Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Bags"
                                name="sumOfpoOrderQuantity"
                                id="sumOfpoOrderQuantity"
                                value={totals?.poTotalBags}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Amount"
                                name="sumOfRate"
                                id="sumOfRate"
                                value={totals?.poTotalAmount}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total CGST"
                                name="poTotalCgst"
                                id="poTotalCgst"
                                value={totals?.poTotalCgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total SGST"
                                name="poTotalSgst"
                                id="poTotalSgst"
                                value={totals?.poTotalSgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total IGST"
                                name="poTotalIgst"
                                id="poTotalIgst"
                                value={totals?.poTotalIgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total CGST 9%"
                                name="poCgstValue_9"
                                id="poCgstValue_9"
                                value={totals?.poCgstValue_9}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total CGST 14%"
                                name="poCgstValue_14"
                                id="poCgstValue_14"
                                // value={totals?.poCgstValue_9}
                                value={totals?.poCgstValue_14}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total SGST 9%"
                                name="poSgstValue_9"
                                id="poSgstValue_9"
                                // value={totals?.poCgstValue_9}
                                value={totals?.poSgstValue_9}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total SGST 14%"
                                name="poSgstValue_14"
                                id="poSgstValue_14"
                                // value={totals?.poCgstValue_9}
                                value={totals?.poSgstValue_14}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Round Off"
                                name="difference"
                                id="difference"
                                value={difference}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Gross Value"
                                name="poTotalAmount"
                                id="poTotalAmount"
                                value={totals?.poTotalNetValue}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Row></Row>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <Row className="mt-4">
                <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                  <button
                    className="btn btnInfo"
                    onClick={handleSave}
                    disabled={disable}
                  >
                    Create Purchase
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <MaterialSelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={handleGetSelectedMaterial}
      />
    </main>
  );
};

export default CreatePurchase;
